import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { browserTracingIntegration, init } from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/**
 * Returns the base URL for the web app.
 *
 * @export
 * @return {string} base URL.
 */
export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

/**
 * Returns the base URL for the API behind this web app.
 *
 * @export
 * @return {string} API base URL.
 */
export function getBaseApiUrl() {
  return `${getBaseUrl()}api`;
}

/**
 * Provider array, used for injection into Angular.
 * @type {*} provider array.
 */
const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
  { provide: 'BASE_API_URL', useFactory: getBaseApiUrl, deps: [] }
];

if (environment.production) {
  init({
    dsn: 'https://15574e5658a54a01b64d6aac52b68f9c@o1210024.ingest.sentry.io/4504323970760704',
    integrations: [browserTracingIntegration()],
    tracePropagationTargets: ['localhost', 'https://app-retailss-dev-001.azurewebsites.net/api'],
    tracesSampleRate: 1
  });

  enableProdMode();
}

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.log(err));
